<template>
  <v-app>
    <template v-if="$route.meta.private">
      <AdminDesign>
        <router-view></router-view>
      </AdminDesign>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <ClosableAlerts ref="closableAlerts" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import AdminDesign from '@/infrastructure/vue/layouts/AdminDesign';
import ClosableAlerts from '@/infrastructure/vue/components/common/alerts/ClosableAlerts';
export default {
  name: 'App',
  components: {
    AdminDesign,
    ClosableAlerts,
  },
  computed: {
    ...mapGetters('login', ['isAuthenticated']),
  },
  data() {
    return {
      messageAlert: {},
    };
  },
  created() {
    window.getApp = this;
    this.$on('OPEN_ALERT', (payload) => {
      this.$refs.closableAlerts.open({ show: true, ...JSON.parse(payload) });
    });
  },
  mounted() {
    this.$store.dispatch('initApplication');
  },
  watch: {
    isAuthenticated(newValue) {
      if (newValue) this.$store.dispatch('login/userDataAction');
    },
  },
};
</script>
